import { ResponseMapper } from './interfaces';

export default function composeResponseMappers(
  first: ResponseMapper,
  second: ResponseMapper
): ResponseMapper {
  return resp => second(first(resp));
}
